import { useAuthContext } from "contexts/AuthContext"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { useState } from "react"
import { coreRequest } from "services/requests"

const prefix = `tutorials/getStarted`
const sendRequest = coreRequest.sendRequest

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()
  const { selectedGroupData } = useAuthContext()

  const getGetStartedStatus = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/status`,
      body: {},
      method: "post",
    })
    if (!response.success) {
      const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
      showAlert(response.message || "Something went wrong", teacherImage)
    }
    setIsFetching(false)
    return response.data
  }

  /**
   * You have to always call this function when the user repeats the get started
   * @returns
   */
  const startGetStarted = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/start`,
      body: {},
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const listGetStartedViewed = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/completedActions`,
      body: null,
      method: "get",
    })
    if (!response.success)
      console.log(response.message || "Something went wrong")
    setIsFetching(false)
    return response.data
  }

  const isGetStartedViewed = async (action, controller) => {
    setIsFetching(true)
    let viewed = true
    const response = await sendRequest({
      endpoint: `${prefix}/completedActions`,
      body: null,
      method: "get",
      controller,
    })
    if (!response.success) {
      console.log(response.message || "Something went wrong")
    } else {
      const data = response?.data?.completedActions || []
      viewed = data.includes(action)
    }
    setIsFetching(false)
    return viewed
  }

  const setGetStartedViewed = async (action) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/completeAction/${action}`,
      body: {},
      method: "post",
    })
    if (!response.success)
      console.log(response.message || "Something went wrong")
    setIsFetching(false)
    return response.data
  }

  const finishGetStarted = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/finishTutorial`,
      body: {},
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const resetGetStarted = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/resetTutorial`,
      body: {},
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const autoGradeActivities = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/gradeActivities`,
      body: {},
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success)
      showAlert(response.message || "Something went wrong", teacherImage)
    setIsFetching(false)
    return response.data
  }

  const completeAllGetStarted = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/completeAllActions`,
      body: {},
      method: "post",
    })
    if (!response.success) {
      const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
      showAlert(response.message || "Something went wrong", teacherImage)
    }
    setIsFetching(false)
    return response.data
  }

  return {
    isFetching,
    getGetStartedStatus,
    startGetStarted,
    listGetStartedViewed,
    isGetStartedViewed,
    setGetStartedViewed,
    finishGetStarted,
    resetGetStarted,
    autoGradeActivities,
    completeAllGetStarted,
  }
}

export default useApi
